module.exports = __webpack_public_path__ + "static/media/menu-icon.aeb99c0e.svg";